import Toggle from 'lib/components/Toggle/Toggle'
import AdminContext from 'lib/context/AdminContext'
import React, { HTMLAttributes, useContext } from 'react'
import { useTranslation } from 'react-i18next'

export default function AdminToggle(props: HTMLAttributes<HTMLLabelElement>) {
  const [t] = useTranslation()
  const { showAdminControls, toggleAdminControls } = useContext(AdminContext)

  return (
    <Toggle
      className="admin-toggle"
      title={t('header.admin.tooltip')}
      inputProps={{ checked: showAdminControls, onChange: toggleAdminControls }}
      {...props}
    />
  )
}
